import { render, staticRenderFns } from "./TituloRelatorioDisciplinas.vue?vue&type=template&id=3d51e692&"
import script from "./TituloRelatorioDisciplinas.vue?vue&type=script&lang=js&"
export * from "./TituloRelatorioDisciplinas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports